module.exports = __webpack_public_path__ + "img/1530753290.d5c95adc.jpg";